var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    className: "rounded-full",
    viewBox: "0 0 237 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8098"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3107",
    x: 29.6797,
    y: 32.5879,
    width: 180.056,
    height: 142.019,
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M191.767 0.544922C164.25 0.544922 0.474609 1.64242 0.474609 0.544922C0.474609 0.544922 0.474609 140.429 0.474609 159.065C0.474609 179.841 23.5318 183.984 25.6334 184.32C25.8128 186.022 28.9779 211.634 57.7076 211.634C72.0169 211.634 236.894 211.634 236.894 211.634C236.894 211.634 236.894 72.4181 236.894 46.5844C236.894 16.9903 219.283 0.544922 191.767 0.544922ZM54.3161 146.265H38.405C38.405 146.265 38.405 91.8454 38.405 82.891C38.405 64.2932 54.3161 64.2932 54.3161 64.2932V146.269V146.265ZM185.359 146.265V64.2932H114.031C115.047 64.3145 129.886 64.9313 129.886 82.891V146.265H113.975V64.2932H54.4997C54.4997 64.2932 54.4997 48.4476 73.1745 48.4476H94.1856C108.328 48.4476 111.758 57.5296 112.596 61.9408C113.428 57.5296 116.863 48.4476 131.005 48.4476H167.061C185.735 48.4476 185.735 64.2932 185.735 64.2932H185.415C186.432 64.3145 201.266 64.9313 201.266 82.891C201.266 91.8454 201.266 146.265 201.266 146.265H185.355H185.359Z",
    fill: "#A3A3A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonPlaceholder);
export default __webpack_public_path__ + "static/media/moon_placeholder.82ab9660182af9193c2ddb3f2af84b26.svg";
export { ForwardRef as ReactComponent };